import Translation from 'components/Translation'
import { useAppErrorApiContext } from 'context/AppErrorContext'
import { useTenantContext } from 'context/TenantContext'
import { useEffect, useState } from 'react'
import { MembershipClientOutput } from 'types/client-membership'
import { calculateCouponTotalAmount } from 'types/coupon'
import { Order, OrderPayment } from 'types/order'
import { getApiRequest } from 'utils/fetch-helper'
import { toCurrency } from 'utils/string-localization-helper'

export default function AmountPaid({
    order,
    price,
    service_id,
    email,
    group_class_availability_id,
}: {
    order?: Order
    price?: number
    service_id?: string
    email?: string
    group_class_availability_id?: string
}) {
    const { tenant } = useTenantContext()
    const { setGlobalError } = useAppErrorApiContext()
    const [discount, setDiscount] = useState<JSX.Element | undefined>(
        undefined
    )
    const [total_payment, setTotalPayment] = useState<
        JSX.Element | undefined
    >(undefined)

    useEffect(() => {
        if (order) {
            const {
                coupon,
                discount,
                fully_paid,
                payments,
                total_amount,
                membership_client_id,
            } = order

            if (membership_client_id && service_id && email && tenant?.id) {
                //TODO: very inefficient, should tell BE to store the discounted amount in the order
                try {
                    const promise = getApiRequest(
                        `/v1/memberships/clients/by-service?tenantId=${tenant.id
                        }&serviceId=${service_id}&clientEmail=${encodeURIComponent(
                            email
                        )}${group_class_availability_id
                            ? `&groupClassAvailabilityId=${group_class_availability_id}`
                            : ''
                        }`
                    )
                    promise.then(
                        (memberships: MembershipClientOutput[]) => {
                            if (memberships) {
                                const membership = memberships.find(
                                    (m) =>
                                        m.membershipClient.id ==
                                        membership_client_id
                                )
                                if (
                                    membership?.servicePrice &&
                                    membership.discountAmount
                                ) {
                                    setDiscount(
                                        <>
                                            -
                                            {toCurrency(
                                                membership.discountAmount
                                            )}
                                        </>
                                    )
                                    setTotalPayment(
                                        <div>
                                            <span>
                                                {toCurrency(
                                                    membership.servicePrice
                                                )}
                                            </span>
                                        </div>
                                    )
                                }
                            }
                        }
                    )
                } catch (error) {
                    setGlobalError(error)
                }
            } else if (!fully_paid && discount && discount.amount == 100) {
                setDiscount(
                    <Translation render_as="div" content_key="free" />
                )
                setTotalPayment(
                    <Translation render_as="div" content_key="free" />
                )
            } else if (coupon?.id) {
                setDiscount(<>-{toCurrency((price as number) - (total_amount as number))}</>)
                setTotalPayment(
                    <div>
                        <span>{toCurrency(total_amount as number)}</span>
                    </div>
                )
            } else if (payments && payments.length > 0) {
                setDiscount(<>-{toCurrency(price as number)}</>)
                setTotalPayment(
                    <div>
                        {payments.map(
                            (
                                payment: OrderPayment,
                                payment_idx: number
                            ) => (
                                <span key={payment_idx}>
                                    {toCurrency(payment.amount)}
                                </span>
                            )
                        )}
                    </div>
                )
            }
        }
    }, [order, service_id, email, tenant?.id])

    return (
        <>
            {total_payment != undefined && (
                <div className="flex flex-col">
                    <div className="flex justify-between py-1 mb-1">
                        {discount != undefined && (
                            <>
                                <Translation
                                    render_as="div"
                                    content_key="discount"
                                />
                                {discount}
                            </>
                        )}
                    </div>
                    <div className="flex justify-between border-t border-gray-300 pt-2 font-bold">
                        <Translation
                            render_as="div"
                            content_key="total_payment_made"
                        />
                        {total_payment}
                    </div>
                </div>
            )}
        </>
    )
}
